import React from "react";
import { format } from "date-fns";

// Shared look for the Cutoff and Retained Net Income cards

// Palette (matches the view switch accent)
export const ACCENT = "#4b44a8";
export const ACCENT_SOFT = "#eeedf8";
export const MUTED = "#8a8fa3";

export const formatCardDate = (date) =>
  date ? format(new Date(date), "MMM dd, yyyy") : "--";

// Card shell style; pass `selected` to highlight the card with the accent
export const cardStyle = ({ selected = false, cursor = "pointer" } = {}) => ({
  cursor,
  boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 1px 3px rgba(16,24,40,0.08)",
  outline: selected ? `2px solid ${ACCENT}` : "1px solid #eceef3",
});

// Small uppercase label used above values
export const CardLabel = ({ children, className = "" }) => (
  <div
    className={`text-uppercase fw-semibold ${className}`}
    style={{ fontSize: "0.68rem", letterSpacing: "0.06em", color: MUTED }}
  >
    {children}
  </div>
);

// Plain icon button for the actions menu; Dropdown.Toggle's default
// caret is not rendered
export const ActionsToggle = React.forwardRef(({ onClick }, ref) => (
  <button
    ref={ref}
    type="button"
    className="btn btn-sm border-0 rounded-circle d-flex align-items-center justify-content-center"
    style={{ width: 32, height: 32, color: MUTED }}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }}
    aria-label="Actions"
  >
    <i className="bx bx-dots-vertical-rounded fs-5"></i>
  </button>
));
ActionsToggle.displayName = "ActionsToggle";

// "From → To" strip
export const PeriodStrip = ({ from, to }) => (
  <div
    className="d-flex align-items-center justify-content-between rounded-3 px-3 py-2"
    style={{ backgroundColor: "#f7f8fb" }}
  >
    <div>
      <CardLabel>From</CardLabel>
      <div className="fw-semibold text-dark">{formatCardDate(from)}</div>
    </div>
    <i className="bx bx-right-arrow-alt fs-4" style={{ color: MUTED }}></i>
    <div className="text-end">
      <CardLabel>To</CardLabel>
      <div className="fw-semibold text-dark">{formatCardDate(to)}</div>
    </div>
  </div>
);
